import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PageHeader, Panel } from "../components/Surface";
import { Button } from "../components/ui/Button";
import { labelize } from "../lib/format";
import { getListing, priceUsd, type Listing as L } from "../lib/marketplace";

export function Listing() {
  const { id } = useParams();
  const [listing, setListing] = useState<L | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (id) getListing(id).then((r) => setListing(r.listing)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <div className="mx-auto max-w-2xl p-6"><p className="text-sm text-danger">Listing not found.</p><Link to="/marketplace" className="text-accent-strong">← Marketplace</Link></div>;
  if (!listing) return <p className="p-6 font-mono text-sm text-muted">Loading…</p>;

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader
        title={listing.title}
        subtitle={`${labelize(listing.category)}${listing.condition ? ` · ${labelize(listing.condition)}` : ""}${listing.location ? ` · ${listing.location}` : ""}`}
      />
      <Link to="/marketplace" className="font-mono text-[11px] text-accent-strong">← Marketplace</Link>

      <Panel>
        <p className="font-display text-2xl font-black text-accent-strong">{priceUsd(listing.price_cents)}</p>
        {listing.status && listing.status !== "active" && (
          <p className="font-mono text-xs font-bold uppercase text-danger">{listing.status}</p>
        )}
        {listing.description && <p className="whitespace-pre-wrap text-sm text-muted">{listing.description}</p>}
        <p className="font-mono text-[11px] text-muted">Listed by {listing.seller_name ?? "a member"} · {new Date(listing.created_at).toLocaleDateString()}</p>
        {listing.seller_profile_id && listing.status === "active" && (
          <Link to={`/messages/to/${listing.seller_profile_id}`}><Button>Contact seller</Button></Link>
        )}
      </Panel>
    </div>
  );
}
